import { useState } from "react";

import useData from "./useData";

const useClient = () => {
  const { getFromServer } = useData();

  const [client, setClient] = useState(null);
  const [clients, setClients] = useState(null);
  const [documents, setDocuments] = useState([]);

  const getClient = async (clientId) => {
    const results = await getFromServer({
      entityName: "Client",
      id: clientId,
    });

    if (results) {
      setClient(results);
      return results;
    }

    setClient(null);
    return null;
  };

  const getClients = async (filter) => {
    const results = await getFromServer({
      entityName: "Client",
      filter,
    });

    if (results) {
      setClients(results);
      return results;
    } else {
      setClients([]);
      return [];
    }
  };

  const getDocuments = async (clientId) => {};

  return {
    getClient,
    client,
    getClients,
    clients,
    getDocuments,
    documents,
  };
};

export default useClient;
